import { useContext } from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { cardStyle, sectionTitleStyle } from "../cardStyles";

interface DocumentsCardProps {
  contractURL?: string;
  durURL?: string;
  certificateURL?: string;
}

const DocumentsCard = ({
  contractURL,
  durURL,
  certificateURL,
}: DocumentsCardProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const docs = [
    { label: translate("newDashboard.policyPage.documents.particular"), url: contractURL },
    { label: translate("newDashboard.policyPage.documents.general"), url: durURL },
    { label: translate("newDashboard.policyPage.documents.certificate"), url: certificateURL },
  ];

  return (
    <div style={cardStyle}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="FileInvoiceIcon" size="XS" color="#4f46e5" />
        <h2 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.policyPage.documents")}
        </h2>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {docs.map((doc, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 0",
              borderBottom: idx < docs.length - 1 ? "1px solid #f3f4f6" : "none",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <GlobalIcon iconName="FileInvoiceIcon" size="XS" color="#6b7280" />
              <span style={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>
                {doc.label}
              </span>
            </div>
            {doc.url ? (
              <button
                onClick={() => window.open(doc.url, "_blank")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  color: "#4f46e5",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                <GlobalIcon iconName="DownloadIcon" size="XS" color="#4f46e5" />
                {translate("newDashboard.policyPage.documents.download")}
              </button>
            ) : (
              <span style={{ fontSize: 13, color: "#d1d5db" }}>—</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsCard;
